import type { FetchQuickCartsParams } from './quickCart.types';

export const quickCartUrls = {
  quickCart: '/carts/quick',
};

export const quickCartQueryKeys = {
  anyQuickCart: () => ['cart', 'quickCart'],
  quickCart: (uuid: string, appMode: string) => [
    'cart',
    'quickCart',
    uuid,
    appMode,
  ],
  quickCarts: (params: FetchQuickCartsParams) => [
    'quickCarts',
    params.storeId,
    params.limit,
  ],
};
